import type { JSX } from 'react'

import { Icon, IconNames } from "/app/libraries/arcana/src/atoms/Icon/index.ts"
import { SecondaryButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBoxBody3, TextBoxMaxLine1HeadExtra10 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

import classes from './style.module.css'

export function Title(): JSX.Element {
  return <AppTitle>Not found</AppTitle>
}

NotFoundPage.displayName = 'NotFoundPage'
export function NotFoundPage(): JSX.Element {
  return (
    <ui.PageWrapper className='error-page'>
      <div className={classes.floating}>
        <Icon name={IconNames.ghost} />
        <TextBoxMaxLine1HeadExtra10 title={'Error 404'} />
        <TextBoxBody3
          title={
            'The page you are looking for does not exist or has been moved.'
          }
        />
        {/* FIXME: button inside anchor is not valid HTML */}
        <a href='/'>
          <SecondaryButton title={'Back Home'} />
        </a>
      </div>
    </ui.PageWrapper>
  )
}
